import type { PayCashierSessionView } from "./CashierType";
import {
  isCashierPayWindowExpired,
  resolveCashierLocalExpiredPrompt,
  type CashierExpiredPrompt,
} from "./cashierExpiredError";
import { resolveCashierCreatedAt } from "./cashierSessionDisplay";

/** 与 orders.status 一致：0 待支付 */
export const ORDER_STATUS_PENDING_PAYMENT = 0;
export const ORDER_STATUS_CANCELED = 5;

export function isCashierOrderPaid(session: PayCashierSessionView): boolean {
  if (session.status === "paid" || Boolean(session.paidAt?.trim())) {
    return true;
  }
  const st = session.orderStatus;
  return st != null && st !== ORDER_STATUS_PENDING_PAYMENT && st !== ORDER_STATUS_CANCELED;
}

export function isCashierOrderPayable(session: PayCashierSessionView): boolean {
  if (isCashierOrderPaid(session)) {
    return false;
  }
  if (session.orderStatus != null && session.orderStatus !== ORDER_STATUS_PENDING_PAYMENT) {
    return false;
  }
  if (session.status === "expired" || session.status === "closed") {
    return false;
  }
  return !isCashierPayWindowExpired(
    resolveCashierCreatedAt(session),
    session.expireAt
  );
}

export function resolveCashierBlockedFromSession(
  session: PayCashierSessionView
): CashierExpiredPrompt | null {
  if (isCashierOrderPaid(session)) {
    return null;
  }
  if (session.orderStatus === ORDER_STATUS_CANCELED || session.status === "closed") {
    return {
      isExpired: true,
      title: "订单已失效",
      description: "该订单已取消，请返回商户页面重新下单。",
    };
  }
  if (
    session.status === "expired" ||
    isCashierPayWindowExpired(resolveCashierCreatedAt(session), session.expireAt)
  ) {
    return resolveCashierLocalExpiredPrompt();
  }
  return null;
}
